import React from 'react';
import { useEffect, useState } from "react"
import './account.css';
import { useAuthContext } from '../../../hooks/useAuthContext';

const Account = () => {

  const {user} = useAuthContext()
  if(!user){
    window.location.href = "/"
  }

  const userInfo = {
    Company: 'ABC',
    Email: 'max@abc.com'
  }

  const openBillingPortal = async () => {

        const response = await fetch('http://localhost:5000/api/create-customer-portal-session', {
            method: 'POST',
           
        })
        const data = await response.json()
        console.log(data)
        if(data){
          console.log('yay?')
         // window.location.href = data.url
        }
        
        
        
    }

  return (
    <div className='accountPage'>
      <div className='accountUserTile'>
        <div className='accountUserTileTitle'>
          Account Settings
          <form >
            <button  type="submit"  onClick = {openBillingPortal}>Manage Subscription</button>
          </form>
        </div>  
        <div className='accountUserInfoContainer'>
          <div className='accountUserInfoText'>Company: BillMcClung.inc</div>
          <div className='accountUserInfoText'>Email: Max@BillMcClung.inc</div>
          
        </div>
      </div>
    </div>
  )
}

export default Account
